
// This is an auto generated file - do not edit!
// Swagger path: /api/UserAction/{userAction}/entity/{entityType}/{recordId}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    UserAction, SystemEntity
} from '@wdx/clmi/clmi-swagger-gen';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class UseractionUseractionEntityEntitytypeRecordidApiService extends BaseApiService {
    
    patch(userAction: UserAction, entityType: SystemEntity, recordId: string, body: any, additional?: string, options = {}): Observable<any> {
        let params = new HttpParams();
        if(additional !== undefined) {
            params = params.append('additional', additional);
        }

        return this._patch<any, any>(
            `/UserAction/${userAction}/entity/${entityType}/${recordId}`,
            body, {
                ...options,
                params,
            }
        );
    }
}
